import type { FC } from 'react';
import { cn } from '../utils/cn.ts';

/** Shared feedback for observed work. It never controls the canvas or the run. */
export const StageProgressLine: FC<{
  text?: string;
  detail?: string;
  working: boolean;
  className?: string;
}> = ({ text, detail, working, className }) => {
  if (!text) {
    return null;
  }
  return (
    <div
      role="status"
      aria-atomic="true"
      data-working={working || undefined}
      className={cn(
        'stage-progress-line flex h-7 min-w-0 items-center gap-3 px-2 text-sm',
        className,
      )}
    >
      <span
        key={text}
        dir="auto"
        title={text}
        className="stage-progress-copy min-w-0 truncate font-medium text-muted-foreground"
      >
        <span className={working ? 'shimmer-text' : undefined}>{text}</span>
      </span>
      {detail && detail !== text ? (
        <span
          key={detail}
          dir="auto"
          title={detail}
          className="stage-progress-copy min-w-0 flex-1 truncate text-muted-foreground"
        >
          {detail}
        </span>
      ) : null}
    </div>
  );
};
